class GeolocalizePopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const popover = this.querySelector('#geo-popover');
    const changeLangTrigger = this.querySelector('.change-lang');

    if (changeLangTrigger) {
      changeLangTrigger.addEventListener('click', () => {
        const details = this.querySelector('details');
        if (details) details.open = !details.open;
      })
    }

    if (popover) {
      if (this.getConsentCookie() != '1') popover.showPopover();

      popover.addEventListener('toggle', (e) => {   
        if(e.newState == 'closed') this.setConsentCookie();
      });
    }
  }

  getConsentCookie() {
    return document.cookie.split(";").find(row => row.includes('general_lang='))?.split('=')[1] || 0;
  }

  setConsentCookie() {
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year
    const expires = "expires=" + date.toUTCString();
    
    document.cookie = `general_lang=${encodeURIComponent(1)}; ${expires}; path=/`;
  }
}

if (!customElements.get('geolocalize-popup')) customElements.define('geolocalize-popup', GeolocalizePopup);